export const MESSAGE_TYPE = {
  NOTIFICATION: 'Notification',
  CHAT_NOTIFICATION: 'ChatNotification',
  EMERGENCY: 'Emergency',
  PIN_DROPPED: 'PinDropped',
  REMOVE_GUARD_OUT_OF_ROSTER: "RemoveGuardOutOfRoster",
  ADD_GUARD_TO_ROSTER: "AddGuardToRoster"
}
